import { API_BASE_URL } from '../config'
import axios from 'axios'
import { getAllEdits } from './edit'

export const LIST_TEXTS = 'LIST_TEXTS'
export const listTexts = texts => ({
	type: LIST_TEXTS,
	texts
})

export const SENT_TEXT = 'SENT_TEXT'
export const sentText = sent => ({
	type: SENT_TEXT,
	sent
})

export const getTexts = uid => dispatch => {
	axios
		.get(`${API_BASE_URL}/text/${uid}`)
		.then(res => {
			dispatch(listTexts(res.data))
		})
}

export const LIST_RECENT_TEXTS = 'LIST_RECENT_TEXTS'
export const listRecentTexts = texts => ({
	type: LIST_RECENT_TEXTS,
	texts
})

export const getRecentTexts = () => dispatch => {
	axios
		.get(`${API_BASE_URL}/text`)
		.then(res => {
			dispatch(getAllEdits(res.data))
			dispatch(listRecentTexts(res.data))
		})
}

export const sendTextToApi = (textObj) => dispatch => {
	const { body, title, authorId, authorName, description } = textObj
	axios
		.post(`${API_BASE_URL}/text`, {
			body,
			title,
			authorId,
			authorName,
			description
		})
		.then(res => {
			dispatch(getRecentTexts())
			dispatch(getTexts(res.data.authorId))
		})
}


export const deleteTextFromApi = (id, uid) => dispatch => {
	axios
		.delete(`${API_BASE_URL}/text/${uid}/${id}`)
		.then(res => {
			dispatch(getRecentTexts())
			dispatch(listTexts(res.data))
		})
}

export const LIST_EDITS_FOR_TEXT = "LIST_EDITS_FOR_TEXT"
export const listEditsForText = edits => ({
	type: LIST_EDITS_FOR_TEXT,
	edits
})

export const getEditsFromApi = id => dispatch => {
	axios
		.get(`${API_BASE_URL}/text/edits/${id}`)
		.then(res => {
			dispatch(listEditsForText(res.data))
	})
}




// WEBPACK FOOTER //
// ./src/actions/text.js